import { Flex } from '@chakra-ui/react'
import RouterUrl from '@constants/router.constant'
import UnderlineLink from '@modules/common/components/underline-link'

const EmptyCartMessage = () => {
  return (
    <Flex
      flexDirection={'column'}
      alignItems={'center'}
      justifyContent={'center'}
      px={8}
      py={24}
      textAlign={'center'}
      bg={'bg'}
    >
      <h1 className="text-2xl-semi font-itc">Your shopping bag is empty</h1>
      <p className="text-base-regular mt-4 mb-6 max-w-[32rem]">
        You don&apos;t have anything in your bag. Let&apos;s change that, use
        the link below to start browsing our products.
      </p>
      <div>
        <UnderlineLink href={RouterUrl.SHOP.ROOT}>
          Explore products
        </UnderlineLink>
      </div>
    </Flex>
  )
}

export default EmptyCartMessage
